export default __webpack_public_path__ + "static/media/foto2.7b311673.jpg";